<template>
  <img :src="require('@/assets/kab20-1.gif')">
</template>
<script>
export default {
  name: "KabLoader"
}
</script>
<style lang="scss">
</style>